import cn from "../../../lib/cn";
import P from "../../../shared/typography/P";
import TableComponent from "../../../shared/ui/Table";
import MemberInput from "../MemberInput";

const CommuneManagerForm = ({
    currentSlide,
    setCurrentSlide,
    additionalInput,
    setAdditionalInputs,
    handleInvite,
    handleQuit,
    admins,
    columns,
    transformedAdmins,
}) => (
    <div className="p-4">
        <div className="flex  justify-between lg:justify-start items-center border-b border-b-blue-250 my-1">
            <div
                role="button"
                onClick={() => {
                    setCurrentSlide(0);
                }}
                className={cn("pb-2 lg:w-1/2", {
                    "border-b-2 border-b-blue ": currentSlide === 0,
                })}
            >
                <P
                    className={cn("text-nowrap lg:w-1/2", {
                        "text-blue font-medium": currentSlide === 0,
                    })}
                >
                    Add Member
                </P>
            </div>
            <div
                role="button"
                onClick={() => {
                    setCurrentSlide(1);
                }}
                className={cn("pb-2", {
                    "border-b-2 border-b-blue ": currentSlide === 1,
                })}
            >
                <P
                    className={cn("text-nowrap", {
                        "text-blue font-medium": currentSlide === 1,
                    })}
                >
                    Existing Members
                </P>
            </div>
        </div>
        <div className="max-h-[500px] overflow-y-scroll">
            {currentSlide === 0 ? (
                <MemberInput
                    inputs={additionalInput}
                    handleInvite={handleInvite}
                    setInputs={setAdditionalInputs}
                    handleQuit={handleQuit}
                    admins={admins}
                />
            ) : (
                <div>
                    {admins && admins.length > 0 ? (
                        <TableComponent
                            columns={columns}
                            data={transformedAdmins}
                            headerColor="bg-gray-170 text-nowrap "
                            additionalRowClassName="border-t border-t-gray-170  rounded-xl"
                            borderStyle="border-collapse border border-gray-200"
                            fontSize="text-xs md:text-sm"
                        />
                    ) : (
                        <div className="flex justify-center items-center">
                            <P className="text-center">No Members Added Yet</P>
                        </div>
                    )}
                </div>
            )}
        </div>
    </div>
);

export default CommuneManagerForm;
